module.exports = __webpack_public_path__ + "static/santeri_raisanen-95c7b3a3c381a8b16f9917345734f9f7.jpg";